export default __webpack_public_path__ + "static/media/four.e39d4cc9.svg";